import URLS from "../constants/api";
import { get_2 } from "./api";

export const downloadRSVPAPI = async (id: string, eventType: string) => {
  const endpoint = `${URLS.DOWNLOAD_RSVP}/${id}/${eventType}`;
  const response = await get_2(endpoint);
  return response;
};
